<template>
  <button
    class="wishlist-icon-btn"
    :class="{ 'in-wishlist': isVariationInWishList }"
    @click.prevent="switchState()"
    ref="addToWishList"
    aria-label="Wishlist"
  >
    <div class="wishlist-icon">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16.1111 3C19.6333 3 22 6.3525 22 9.48C22 15.8138 12.1778 21 12 21C11.8222 21 2 15.8138 2 9.48C2 6.3525 4.36667 3 7.88889 3C9.91111 3 11.2333 4.02375 12 4.92375C12.7667 4.02375 14.0889 3 16.1111 3Z"
          stroke="black"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
  </button>
</template>

<script>
import { isNullOrUndefined } from "../../helper/utils";
import { mapState } from "vuex";

const NotificationService = require("../../services/NotificationService");

export default {
  name: "add-to-wish-list",

  props: {
    variationId: Number,
  },

  inject: {
    itemId: {
      default: null,
    },
  },

  data() {
    return {
      isLoading: false,
    };
  },

  computed: {
    isVariationInWishList() {
      return this.wishListIds.includes(this.currentVariationId);
    },

    currentVariationId() {
      return !isNullOrUndefined(this.variationId)
        ? this.variationId
        : this.currentVariationVariationId;
    },

    currentVariationVariationId() {
      const currentVariation =
        this.$store.getters[`${this.itemId}/currentItemVariation`];

      if (isNullOrUndefined(currentVariation)) {
        return null;
      }

      return (
        currentVariation &&
        currentVariation.variation &&
        currentVariation.variation.id
      );
    },

    ...mapState({
      wishListIds: (state) => state.wishList.wishListIds,
    }),
  },

  methods: {
    switchState() {
      if (this.isVariationInWishList) {
        this.removeFromWishList();
      } else {
        this.addToWishList();
      }
    },

    addToWishList() {
      if (!this.isLoading) {
        this.isLoading = true;
        this.$store
          .dispatch("addToWishList", parseInt(this.currentVariationId))
          .then(
            (response) => {
              this.isLoading = false;

              NotificationService.success(
                this.$translate("Ceres::Template.singleItemWishListAdded")
              ).closeAfter(3000);
            },
            (error) => {
              this.isLoading = false;
            }
          );
      }
    },

    removeFromWishList() {
      if (!this.isLoading) {
        this.isLoading = true;
        this.$store
          .dispatch("removeWishListItem", {
            id: parseInt(this.currentVariationId),
          })
          .then(
            (response) => {
              this.isLoading = false;

              NotificationService.success(
                this.$translate("Ceres::Template.singleItemWishListRemoved")
              ).closeAfter(3000);
            },
            (error) => {
              this.isLoading = false;
            }
          );
      }
    },
  },
};
</script>
